// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2D264"};